/**
 * Request classification (docs/domain/PROCUREMENT_DOMAIN.md §3). Stored on the request,
 * proposed by the model each turn and overridable by the requester. They decide which
 * fields are mandatory (see the field registry, ADR-0013 / ADR-0016).
 */
export const ENGAGEMENT_SHAPES = [
  "STAFF_AUGMENTATION",
  "WORK_PACKAGE",
  "MANAGED_SERVICE",
  "GOODS_OR_LICENCES",
] as const;
export type EngagementShape = (typeof ENGAGEMENT_SHAPES)[number];

export const SIZE_TIERS = ["LIGHT", "STANDARD", "DEEP"] as const;
export type SizeTier = (typeof SIZE_TIERS)[number];

/** People are engaged (individuals or a team under TeamSystem direction): staffing fields apply. */
export function isPeopleShaped(shape: EngagementShape): boolean {
  return shape === "STAFF_AUGMENTATION";
}
